import Navbar from "./Navbar";

// TimeMaster Pro is a standalone vanilla-JS app (Tailwind CDN, global handlers,
// localStorage under tm_* keys). It runs in an iframe so its global styles and
// scripts stay isolated from the rest of the UI.
const TIME_MASTER_HTML = `<!DOCTYPE html>
<html lang="de" class="h-full bg-slate-50">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>TimeMaster Pro - Arbeitszeiterfassung & Urlaubsverwaltung</title>

    <!-- Tailwind CSS -->
    <script src="https://cdn.tailwindcss.com"></script>
    <!-- FontAwesome Icons -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
    <!-- Chart.js -->
    <script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
    <script>
        tailwind.config = {
            darkMode: 'class',
            theme: {
                extend: {
                    colors: {
                        brand: {
                            50: '#f0f9ff',
                            100: '#e0f2fe',
                            500: '#0ea5e9',
                            600: '#0284c7',
                            700: '#0369a1',
                            900: '#0c4a6e',
                        }
                    }
                }
            }
        }
    </script>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        body { font-family: 'Inter', sans-serif; }
        .custom-scrollbar::-webkit-scrollbar { height: 8px; width: 8px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
    </style>
</head>
<body class="h-full text-slate-800 flex flex-col antialiased selection:bg-brand-500 selection:text-white">

<div id="toast-container" class="fixed top-5 right-5 z-50 flex flex-col gap-2 max-w-sm w-full pointer-events-none"></div>

<!-- Login View -->
<div id="login-view" class="min-h-screen flex items-center justify-center p-4 bg-slate-900 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black">
    <div class="w-full max-w-md">
        <div class="text-center mb-8">
            <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-600 text-white shadow-lg shadow-brand-500/30 mb-4">
                <i class="fa-solid fa-clock-rotate-left text-3xl"></i>
            </div>
            <h1 class="text-3xl font-bold text-white tracking-tight">TimeMaster Pro</h1>
            <p class="text-slate-400 text-sm mt-1">Zeiterfassung & Urlaubsverwaltung</p>
        </div>

        <div class="bg-slate-800/90 border border-slate-700/60 p-8 rounded-2xl shadow-2xl backdrop-blur-xl">
            <h2 class="text-xl font-semibold text-white mb-6">Anmelden</h2>
            <form id="login-form" onsubmit="handleLogin(event)" class="space-y-5">
                <div>
                    <label class="block text-xs font-semibold text-slate-300 uppercase tracking-wider mb-2">Benutzername</label>
                    <div class="relative">
                        <span class="absolute inset-y-0 left-0 flex items-center pl-3.5 text-slate-400">
                            <i class="fa-solid fa-user"></i>
                        </span>
                        <input type="text" id="login-username" required class="w-full pl-10 pr-4 py-3 bg-slate-900/80 border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition text-sm" placeholder="z.B. admin oder max">
                    </div>
                </div>
                <div>
                    <label class="block text-xs font-semibold text-slate-300 uppercase tracking-wider mb-2">Passwort</label>
                    <div class="relative">
                        <span class="absolute inset-y-0 left-0 flex items-center pl-3.5 text-slate-400">
                            <i class="fa-solid fa-lock"></i>
                        </span>
                        <input type="password" id="login-password" required class="w-full pl-10 pr-4 py-3 bg-slate-900/80 border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition text-sm" placeholder="••••••••">
                    </div>
                </div>
                <button type="submit" class="w-full py-3.5 px-4 bg-brand-600 hover:bg-brand-500 text-white font-semibold rounded-xl shadow-lg shadow-brand-600/30 transition duration-150 flex items-center justify-center gap-2 text-sm">
                    <span>Anmelden</span>
                    <i class="fa-solid fa-arrow-right"></i>
                </button>
            </form>

            
        </div>
    </div>
</div>

<div id="app-view" class="hidden min-h-screen flex flex-col bg-slate-100">
    <header class="bg-slate-900 text-white sticky top-0 z-30 shadow-md">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex items-center justify-between h-16">
                <div class="flex items-center space-x-3">
                    <div class="w-10 h-10 rounded-xl bg-brand-600 flex items-center justify-center text-white font-bold shadow-md">
                        <i class="fa-solid fa-clock-rotate-left text-lg"></i>
                    </div>
                    <div>
                        <span class="font-bold text-lg tracking-tight">TimeMaster</span>
                        <span class="text-xs bg-brand-500/20 text-brand-400 border border-brand-500/30 px-2 py-0.5 rounded-full ml-2 font-medium" id="user-role-badge">Admin</span>
                    </div>
                </div>

                <div class="flex items-center space-x-4">
                    <div class="text-right hidden sm:block">
                        <div class="text-sm font-semibold text-slate-200" id="header-user-name">Max Mustermann</div>
                        <div class="text-xs text-slate-400" id="header-user-username">@max</div>
                    </div>
                    <button onclick="logout()" title="Abmelden" class="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition flex items-center gap-2 text-sm font-medium">
                        <i class="fa-solid fa-right-from-bracket text-lg"></i>
                        <span class="hidden sm:inline">Abmelden</span>
                    </button>
                </div>
            </div>
        </div>
    </header>

    <main class="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <!-- Section: Employee View -->
        <div id="section-employee" class="space-y-6">
            <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white p-6 rounded-2xl shadow-sm border border-slate-200/80">
                <div>
                    <h2 class="text-2xl font-bold text-slate-900" id="emp-welcome">Willkommen zurück!</h2>
                    <p class="text-slate-500 text-sm mt-1">Erfassen Sie Ihre täglichen Arbeitszeiten, Urlaubstage und Krankheitstage.</p>
                </div>
                <div class="flex flex-wrap gap-2">
                    <button onclick="openTimeModal()" class="px-4 py-2.5 bg-brand-600 hover:bg-brand-700 text-white rounded-xl font-medium text-sm transition shadow-sm flex items-center gap-2">
                        <i class="fa-solid fa-plus"></i> Arbeitszeit eintragen
                    </button>
                    <button onclick="openAbsenceModal()" class="px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium text-sm transition shadow-sm flex items-center gap-2">
                        <i class="fa-solid fa-calendar-plus"></i> Urlaub / Krankheit
                    </button>
                </div>
            </div>

            <!-- Employee Stat Cards -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-business-time"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Stunden (Diesen Monat)</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-emp-month-hours">0 h</h3>
                    </div>
                </div>

                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-umbrella-beach"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Resturlaub (Jahr)</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-emp-vacation-remaining">0 Tage</h3>
                        <p class="text-xs text-slate-500 mt-0.5" id="stat-emp-vacation-total">von 0 Tagen genützt</p>
                    </div>
                </div>

                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-bed"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Krankheitstage</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-emp-sick-days">0 Tage</h3>
                        <p class="text-xs text-slate-500 mt-0.5">Im laufenden Jahr</p>
                    </div>
                </div>
            </div>

            <div class="bg-white rounded-2xl shadow-sm border border-slate-200/80 overflow-hidden">
                <div class="border-b border-slate-200 px-6 pt-4 flex flex-wrap gap-6 text-sm font-medium">
                    <button onclick="switchEmpTab('hours')" id="emp-tab-hours" class="pb-4 border-b-2 border-brand-600 text-brand-600 font-semibold flex items-center gap-2">
                        <i class="fa-solid fa-list-check"></i> Meine Arbeitsstunden
                    </button>
                    <button onclick="switchEmpTab('absences')" id="emp-tab-absences" class="pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2">
                        <i class="fa-solid fa-calendar-days"></i> Meine Urlaub & Krankmeldungen
                    </button>
                    <button onclick="switchEmpTab('yearly')" id="emp-tab-yearly" class="pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2">
                        <i class="fa-solid fa-chart-pie"></i> Monats & Jahresstatistik
                    </button>
                </div>

                <!-- Sub Tab: Hours -->
                <div id="emp-sub-hours" class="p-6">
                    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4">
                        <h3 class="font-bold text-slate-800 text-lg">Zeiteinträge</h3>
                        <div class="flex items-center gap-2">
                            <label class="text-xs text-slate-500 font-medium">Monat filtern:</label>
                            <input type="month" id="emp-filter-month" onchange="renderEmpHoursTable()" class="px-3 py-1.5 border border-slate-300 rounded-lg text-sm focus:outline-none focus:border-brand-500">
                        </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="w-full text-left text-sm text-slate-600">
                            <thead class="bg-slate-50 text-slate-500 uppercase text-xs font-semibold">
                                <tr>
                                    <th class="px-4 py-3 rounded-l-lg">Datum</th>
                                    <th class="px-4 py-3">Zeiten</th>
                                    <th class="px-4 py-3">Gesamtzeit</th>
                                    <th class="px-4 py-3 text-right rounded-r-lg">Aktion</th>
                                </tr>
                            </thead>
                            <tbody id="emp-hours-tbody" class="divide-y divide-slate-100"></tbody>
                        </table>
                    </div>
                </div>

                <!-- Sub Tab: Absences -->
                <div id="emp-sub-absences" class="p-6 hidden">
                    <div class="flex justify-between items-center mb-4">
                        <div>
                            <h3 class="font-bold text-slate-800 text-lg">Eingetragene Abwesenheiten</h3>
                            <p class="text-xs text-slate-500 mt-0.5">Urlaube und Krankmeldungen einsehen, anpassen oder stornieren.</p>
                        </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="w-full text-left text-sm text-slate-600">
                            <thead class="bg-slate-50 text-slate-500 uppercase text-xs font-semibold">
                                <tr>
                                    <th class="px-4 py-3 rounded-l-lg">Art</th>
                                    <th class="px-4 py-3">Zeitraum</th>
                                    <th class="px-4 py-3">Tage</th>
                                    <th class="px-4 py-3">Status</th>
                                    <th class="px-4 py-3 text-right rounded-r-lg">Aktion</th>
                                </tr>
                            </thead>
                            <tbody id="emp-absences-tbody" class="divide-y divide-slate-100"></tbody>
                        </table>
                    </div>
                </div>

                <!-- Sub Tab: Statistics -->
                <div id="emp-sub-yearly" class="p-6 hidden">
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div>
                            <h4 class="font-bold text-slate-800 mb-3">Arbeitsstunden Verlauf</h4>
                            <div class="h-64 relative bg-slate-50 rounded-xl p-4 border border-slate-100">
                                <canvas id="chart-emp-hours"></canvas>
                            </div>
                        </div>
                        <div>
                            <h4 class="font-bold text-slate-800 mb-3">Jahresübersicht Urlaub & Krankheit</h4>
                            <div class="h-64 relative bg-slate-50 rounded-xl p-4 border border-slate-100">
                                <canvas id="chart-emp-vacation"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section: Admin View -->
        <div id="section-admin" class="space-y-6 hidden">
            <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white p-6 rounded-2xl shadow-sm border border-slate-200/80">
                <div>
                    <h2 class="text-2xl font-bold text-slate-900">Administrator Dashboard</h2>
                    <p class="text-slate-500 text-sm mt-1">Gesamtkontrolle über Mitarbeiter, Arbeitszeiten, Urlaub, Krankmeldungen und Änderungsprotokoll.</p>
                </div>
                <div class="flex flex-wrap gap-2">
                    <button onclick="openUserModal()" class="px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-medium text-sm transition shadow-sm flex items-center gap-2">
                        <i class="fa-solid fa-user-plus"></i> Neuer Mitarbeiter
                    </button>
                    <button onclick="exportCSV()" class="px-4 py-2.5 bg-slate-800 hover:bg-slate-900 text-white rounded-xl font-medium text-sm transition shadow-sm flex items-center gap-2">
                        <i class="fa-solid fa-file-csv"></i> Daten als CSV Exportieren
                    </button>
                </div>
            </div>

            <!-- Admin Stat Cards -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-users"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Mitarbeiter Gesamt</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-admin-users-count">0</h3>
                        <p class="text-xs text-slate-500 mt-0.5">Aktive Accounts</p>
                    </div>
                </div>

                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-clock"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Stunden (Diesen Monat)</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-admin-total-hours">0 h</h3>
                        <p class="text-xs text-slate-500 mt-0.5">Betriebsweit erfasst</p>
                    </div>
                </div>

                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-plane-departure"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Urlaub Anträge</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-admin-pending-vacations">0 Offen</h3>
                        <p class="text-xs text-slate-500 mt-0.5">Warten auf Genehmigung</p>
                    </div>
                </div>

                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200/80 flex items-center space-x-4">
                    <div class="w-12 h-12 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center text-xl shrink-0">
                        <i class="fa-solid fa-house-medical"></i>
                    </div>
                    <div>
                        <p class="text-xs font-medium text-slate-500 uppercase tracking-wider">Krankmeldungen</p>
                        <h3 class="text-2xl font-bold text-slate-800" id="stat-admin-sick-count">0</h3>
                        <p class="text-xs text-slate-500 mt-0.5">Einträge im Jahr</p>
                    </div>
                </div>
            </div>

            <!-- Admin Content Tabs -->
            <div class="bg-white rounded-2xl shadow-sm border border-slate-200/80 overflow-hidden">
                <div class="border-b border-slate-200 px-6 pt-4 flex flex-wrap gap-6 text-sm font-medium">
                    <button onclick="switchAdminTab('users')" id="admin-tab-users" class="pb-4 border-b-2 border-brand-600 text-brand-600 font-semibold flex items-center gap-2">
                        <i class="fa-solid fa-users"></i> Mitarbeiterverwaltung
                    </button>
                    <button onclick="switchAdminTab('calendar')" id="admin-tab-calendar" class="pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2">
                        <i class="fa-solid fa-calendar-week text-indigo-600"></i> Team-Urlaubskalender
                    </button>
                    <button onclick="switchAdminTab('all-hours')" id="admin-tab-all-hours" class="pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2">
                        <i class="fa-solid fa-clock-rotate-left"></i> Alle Arbeitszeiten
                    </button>
                    <button onclick="switchAdminTab('all-absences')" id="admin-tab-all-absences" class="pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2">
                        <i class="fa-solid fa-plane"></i> Urlaubs- & Krankheitsverwaltung
                    </button>
                    <button onclick="switchAdminTab('logs')" id="admin-tab-logs" class="pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2">
                        <i class="fa-solid fa-list-check text-amber-500"></i> Änderungsprotokoll & Historie
                    </button>
                </div>

                <!-- Admin Tab: Users -->
                <div id="admin-sub-users" class="p-6">
                    <div class="overflow-x-auto">
                        <table class="w-full text-left text-sm text-slate-600">
                            <thead class="bg-slate-50 text-slate-500 uppercase text-xs font-semibold">
                                <tr>
                                    <th class="px-4 py-3 rounded-l-lg">Name</th>
                                    <th class="px-4 py-3">Benutzername</th>
                                    <th class="px-4 py-3">Rolle</th>
                                    <th class="px-4 py-3">Stundenlohn</th>
                                    <th class="px-4 py-3">Urlaubsanspruch</th>
                                    <th class="px-4 py-3">Genommen</th>
                                    <th class="px-4 py-3">Resturlaub</th>
                                    <th class="px-4 py-3 text-right rounded-r-lg">Aktionen</th>
                                </tr>
                            </thead>
                            <tbody id="admin-users-tbody" class="divide-y divide-slate-100"></tbody>
                        </table>
                    </div>
                </div>

                <!-- Admin Tab: Vacation Calendar -->
                <div id="admin-sub-calendar" class="p-6 hidden space-y-4">
                    <div id="admin-vacation-calendar-container"></div>
                </div>

                <!-- Admin Tab: All Hours & Monthly Summary -->
                <div id="admin-sub-all-hours" class="p-6 hidden space-y-6">
                    <!-- Monatsübersicht pro Mitarbeiter -->
                    <div class="bg-slate-50 p-5 rounded-2xl border border-slate-200/80">
                        <div class="flex items-center justify-between mb-3">
                            <h4 class="font-bold text-slate-800 text-sm flex items-center gap-2">
                                <i class="fa-solid fa-chart-column text-brand-600"></i> Monatsübersicht pro Mitarbeiter
                            </h4>
                        </div>
                        <div class="overflow-x-auto">
                            <table class="w-full text-left text-xs text-slate-600">
                                <thead class="bg-slate-200/70 text-slate-700 font-semibold uppercase">
                                    <tr>
                                        <th class="px-3 py-2 rounded-l-lg">Mitarbeiter</th>
                                        <th class="px-3 py-2">Monat</th>
                                        <th class="px-3 py-2">Anzahl Einträge</th>
                                        <th class="px-3 py-2">Gesamtstunden</th>
                                        <th class="px-3 py-2 rounded-r-lg text-right">Berechneter Verdienst</th>
                                    </tr>
                                </thead>
                                <tbody id="admin-monthly-summary-tbody" class="divide-y divide-slate-200/60"></tbody>
                            </table>
                        </div>
                    </div>

                    <div>
                        <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4">
                            <h3 class="font-bold text-slate-800 text-lg">Einzeleinträge & Bearbeitung</h3>
                            <div class="flex flex-wrap gap-2">
                                <select id="admin-filter-user" onchange="renderAdminHoursTable()" class="px-3 py-1.5 border border-slate-300 rounded-lg text-sm">
                                    <option value="ALL">Alle Mitarbeiter</option>
                                </select>
                                <input type="month" id="admin-filter-month" onchange="renderAdminHoursTable()" class="px-3 py-1.5 border border-slate-300 rounded-lg text-sm">
                            </div>
                        </div>
                        <div class="overflow-x-auto">
                            <table class="w-full text-left text-sm text-slate-600">
                                <thead class="bg-slate-50 text-slate-500 uppercase text-xs font-semibold">
                                    <tr>
                                        <th class="px-4 py-3 rounded-l-lg">Mitarbeiter</th>
                                        <th class="px-4 py-3">Datum</th>
                                        <th class="px-4 py-3">Zeiten</th>
                                        <th class="px-4 py-3">Stunden</th>
                                        <th class="px-4 py-3">Status</th>
                                        <th class="px-4 py-3 text-right rounded-r-lg">Aktion</th>
                                    </tr>
                                </thead>
                                <tbody id="admin-hours-tbody" class="divide-y divide-slate-100"></tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Admin Tab: All Absences -->
                <div id="admin-sub-all-absences" class="p-6 hidden">
                    <div class="flex justify-between items-center mb-4">
                        <h3 class="font-bold text-slate-800 text-lg">Komplettübersicht Urlaub & Krankmeldungen</h3>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="w-full text-left text-sm text-slate-600">
                            <thead class="bg-slate-50 text-slate-500 uppercase text-xs font-semibold">
                                <tr>
                                    <th class="px-4 py-3 rounded-l-lg">Mitarbeiter</th>
                                    <th class="px-4 py-3">Typ</th>
                                    <th class="px-4 py-3">Zeitraum</th>
                                    <th class="px-4 py-3">Tage</th>
                                    <th class="px-4 py-3">Status</th>
                                    <th class="px-4 py-3 text-right rounded-r-lg">Aktionen</th>
                                </tr>
                            </thead>
                            <tbody id="admin-absences-tbody" class="divide-y divide-slate-100"></tbody>
                        </table>
                    </div>
                </div>

                <!-- Admin Tab: Global Activity Log & History -->
                <div id="admin-sub-logs" class="p-6 hidden space-y-4">
                    <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 bg-slate-50 p-4 rounded-xl border border-slate-200">
                        <div class="flex items-center gap-2">
                            <i class="fa-solid fa-clock-rotate-left text-amber-500 text-xl"></i>
                            <div>
                                <h3 class="font-bold text-slate-800 text-base">Zentrales Änderungsprotokoll & Historie</h3>
                                <p class="text-xs text-slate-500">Nachvollziehbare Auflistung aller Eintragungen, Urlaubsänderungen, Genehmigungen und Löschungen.</p>
                            </div>
                        </div>
                        <div class="flex flex-wrap gap-2 w-full md:w-auto">
                            <select id="log-filter-user" onchange="renderAdminLogsTable()" class="px-3 py-1.5 bg-white border border-slate-300 rounded-lg text-xs font-medium">
                                <option value="ALL">Alle Mitarbeiter</option>
                            </select>
                            <select id="log-filter-category" onchange="renderAdminLogsTable()" class="px-3 py-1.5 bg-white border border-slate-300 rounded-lg text-xs font-medium">
                                <option value="ALL">Alle Kategorien</option>
                                <option value="Urlaub">Urlaub</option>
                                <option value="Krankheit">Krankheit</option>
                                <option value="Arbeitszeit">Arbeitszeit</option>
                            </select>
                            <select id="log-filter-action" onchange="renderAdminLogsTable()" class="px-3 py-1.5 bg-white border border-slate-300 rounded-lg text-xs font-medium">
                                <option value="ALL">Alle Aktionen</option>
                                <option value="Erstellt">Erstellt</option>
                                <option value="Geändert">Geändert</option>
                                <option value="Genehmigt">Genehmigt</option>
                                <option value="Abgelehnt">Abgelehnt</option>
                                <option value="Gelöscht">Gelöscht</option>
                            </select>
                        </div>
                    </div>

                    <div class="overflow-x-auto">
                        <table class="w-full text-left text-sm text-slate-600">
                            <thead class="bg-slate-50 text-slate-500 uppercase text-xs font-semibold">
                                <tr>
                                    <th class="px-4 py-3 rounded-l-lg">Datum & Uhrzeit</th>
                                    <th class="px-4 py-3">Mitarbeiter</th>
                                    <th class="px-4 py-3">Kategorie</th>
                                    <th class="px-4 py-3">Aktion</th>
                                    <th class="px-4 py-3 rounded-r-lg">Details / Beschreibung</th>
                                </tr>
                            </thead>
                            <tbody id="admin-logs-tbody" class="divide-y divide-slate-100"></tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- Modal: Arbeitszeit eintragen / bearbeiten -->
<div id="modal-time" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center hidden p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-slate-100">
        <div class="bg-slate-900 text-white p-5 flex justify-between items-center">
            <h3 class="font-bold text-lg" id="modal-time-title">Arbeitszeit eintragen</h3>
            <button onclick="closeModal('modal-time')" class="text-slate-400 hover:text-white"><i class="fa-solid fa-xmark text-xl"></i></button>
        </div>
        <form id="form-time" onsubmit="handleSaveTime(event)" class="p-6 space-y-4">
            <input type="hidden" id="time-entry-id">
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Datum</label>
                <input type="date" id="time-date" required class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-brand-500">
            </div>
            <div class="grid grid-cols-2 gap-4">
                <div>
                    <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Beginn</label>
                    <input type="time" id="time-start" value="09:30" required class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-brand-500">
                </div>
                <div>
                    <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Ende</label>
                    <input type="time" id="time-end" value="18:00" required class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-brand-500">
                </div>
            </div>
            <div class="pt-4 flex justify-end gap-3">
                <button type="button" onclick="closeModal('modal-time')" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium rounded-xl">Abbrechen</button>
                <button type="submit" class="px-4 py-2 bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium rounded-xl shadow-sm">Speichern</button>
            </div>
        </form>
    </div>
</div>

<!-- Modal: Abwesenheit (Urlaub/Krankheit) eintragen / bearbeiten -->
<div id="modal-absence" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center hidden p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-slate-100">
        <div class="bg-indigo-900 text-white p-5 flex justify-between items-center">
            <h3 class="font-bold text-lg" id="modal-absence-title">Urlaub oder Krankheit eintragen</h3>
            <button onclick="closeModal('modal-absence')" class="text-indigo-300 hover:text-white"><i class="fa-solid fa-xmark text-xl"></i></button>
        </div>
        <form id="form-absence" onsubmit="handleSaveAbsence(event)" class="p-6 space-y-4">
            <input type="hidden" id="absence-entry-id">
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Art der Abwesenheit</label>
                <select id="absence-type" class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-indigo-500">
                    <option value="Urlaub">Urlaub</option>
                    <option value="Krankheit">Krankheit / Krankmeldung</option>
                </select>
            </div>
            <div class="grid grid-cols-2 gap-4">
                <div>
                    <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Von Datum</label>
                    <input type="date" id="absence-start" required class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-indigo-500">
                </div>
                <div>
                    <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Bis Datum</label>
                    <input type="date" id="absence-end" required class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-indigo-500">
                </div>
            </div>
            <p class="text-xs text-amber-600 bg-amber-50 border border-amber-200 p-2.5 rounded-lg flex items-center gap-1.5">
                <i class="fa-solid fa-circle-info text-amber-500"></i>
                <span>Hinweis: Das Bearbeiten eines bereits genehmigten Urlaubs erfordert eine erneute Freigabe.</span>
            </p>
            <div class="pt-2 flex justify-end gap-3">
                <button type="button" onclick="closeModal('modal-absence')" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium rounded-xl">Abbrechen</button>
                <button type="submit" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-xl shadow-sm" id="btn-save-absence">Speichern / Absenden</button>
            </div>
        </form>
    </div>
</div>

<!-- Modal: Mitarbeiter anlegen/bearbeiten -->
<div id="modal-user" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center hidden p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-slate-100">
        <div class="bg-emerald-900 text-white p-5 flex justify-between items-center">
            <h3 class="font-bold text-lg" id="modal-user-title">Mitarbeiter anlegen</h3>
            <button onclick="closeModal('modal-user')" class="text-emerald-300 hover:text-white"><i class="fa-solid fa-xmark text-xl"></i></button>
        </div>
        <form id="form-user" onsubmit="handleSaveUser(event)" class="p-6 space-y-4">
            <input type="hidden" id="user-edit-id">
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Vollständiger Name</label>
                <input type="text" id="user-name" required placeholder="z.B. Julia Becker" class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-emerald-500">
            </div>
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Benutzername</label>
                <input type="text" id="user-username" required placeholder="z.B. julia.becker" class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-emerald-500">
            </div>
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Passwort</label>
                <input type="text" id="user-password" required placeholder="••••••••" class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-emerald-500">
            </div>
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Rolle</label>
                <select id="user-role" class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-emerald-500">
                    <option value="user">Mitarbeiter</option>
                    <option value="admin">Administrator</option>
                </select>
            </div>
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Stundenlohn (€/Std.)</label>
                <input type="number" step="0.50" id="user-hourly-rate" value="20.00" required placeholder="z.B. 22.50" class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-emerald-500">
            </div>
            <div>
                <label class="block text-xs font-semibold text-slate-600 uppercase mb-1">Urlaubsanspruch (Tage/Jahr)</label>
                <input type="number" id="user-vacation-days" value="30" required class="w-full px-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:outline-none focus:border-emerald-500">
            </div>
            <div class="pt-4 flex justify-end gap-3">
                <button type="button" onclick="closeModal('modal-user')" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium rounded-xl">Abbrechen</button>
                <button type="submit" class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-xl shadow-sm">Speichern</button>
            </div>
        </form>
    </div>
</div>

<!-- Modal: Audit Log Einzelansicht -->
<div id="modal-audit-log" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center hidden p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden border border-slate-100">
        <div class="bg-slate-900 text-white p-5 flex justify-between items-center">
            <h3 class="font-bold text-lg flex items-center gap-2">
                <i class="fa-solid fa-clock-rotate-left text-amber-400"></i> Änderungshistorie (Zeiteintrag)
            </h3>
            <button onclick="closeModal('modal-audit-log')" class="text-slate-400 hover:text-white"><i class="fa-solid fa-xmark text-xl"></i></button>
        </div>
        <div class="p-6 space-y-4 max-h-[70vh] overflow-y-auto" id="audit-log-content"></div>
        <div class="bg-slate-50 px-6 py-3 border-t border-slate-100 flex justify-end">
            <button onclick="closeModal('modal-audit-log')" class="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 text-sm font-medium rounded-xl">Schließen</button>
        </div>
    </div>
</div>

<script>
const STORAGE_KEYS = {
    USERS: 'tm_users_v3',
    HOURS: 'tm_hours_v3',
    ABSENCES: 'tm_absences_v3',
    LOGS: 'tm_logs_v3',
    CURRENT_USER: 'tm_current_user_v3'
};

let currentUser = null;
let chartHoursInstance = null;
let chartVacationInstance = null;

// Calendar View State
let calViewMode = 'grid'; // 'grid' or 'timeline'
let calYearMonth = new Date().toISOString().substring(0, 7); // 'YYYY-MM'
let calFilterType = 'ALL'; // 'ALL', 'Urlaub', 'Krankheit'

const db = {
    getUsers: () => JSON.parse(localStorage.getItem(STORAGE_KEYS.USERS) || '[]'),
    saveUsers: (users) => localStorage.setItem(STORAGE_KEYS.USERS, JSON.stringify(users)),
    getHours: () => JSON.parse(localStorage.getItem(STORAGE_KEYS.HOURS) || '[]'),
    saveHours: (hours) => localStorage.setItem(STORAGE_KEYS.HOURS, JSON.stringify(hours)),
    getAbsences: () => JSON.parse(localStorage.getItem(STORAGE_KEYS.ABSENCES) || '[]'),
    saveAbsences: (absences) => localStorage.setItem(STORAGE_KEYS.ABSENCES, JSON.stringify(absences)),
    getLogs: () => JSON.parse(localStorage.getItem(STORAGE_KEYS.LOGS) || '[]'),
    saveLogs: (logs) => localStorage.setItem(STORAGE_KEYS.LOGS, JSON.stringify(logs)),
    getCurrentUser: () => JSON.parse(localStorage.getItem(STORAGE_KEYS.CURRENT_USER) || 'null'),
    setCurrentUser: (user) => localStorage.setItem(STORAGE_KEYS.CURRENT_USER, JSON.stringify(user))
};

window.logActivity = function(userId, userName, category, action, description) {
    const logs = db.getLogs();
    const newLog = {
        id: 'log-' + Date.now(),
        timestamp: new Date().toISOString(),
        userId,
        userName,
        category, // 'Urlaub', 'Krankheit', 'Arbeitszeit', 'Benutzer'
        action,   // 'Erstellt', 'Geändert', 'Genehmigt', 'Abgelehnt', 'Gelöscht'
        description
    };
    logs.unshift(newLog); // latest first
    db.saveLogs(logs);
};

window.initDatabase = function() {
    if (!localStorage.getItem(STORAGE_KEYS.USERS)) {
        const defaultUsers = [
            { id: 'u-1', name: 'Administrator', username: 'admin', password: 'admin123', role: 'admin', hourlyRate: 35.00, vacationQuota: 30 },
            { id: 'u-2', name: 'Max Mustermann', username: 'max', password: 'max123', role: 'user', hourlyRate: 22.50, vacationQuota: 30 },
            { id: 'u-3', name: 'Anna Schmidt', username: 'anna', password: 'anna123', role: 'user', hourlyRate: 24.00, vacationQuota: 30 }
        ];
        db.saveUsers(defaultUsers);
    }

    if (!localStorage.getItem(STORAGE_KEYS.HOURS)) {
        const today = new Date().toISOString().split('T')[0];
        const defaultHours = [
            { id: 'h-1', userId: 'u-2', date: today, start: '09:30', end: '18:00', isEdited: false, editHistory: [] },
            { id: 'h-2', userId: 'u-3', date: today, start: '08:00', end: '16:30', isEdited: false, editHistory: [] }
        ];
        db.saveHours(defaultHours);
    }

    if (!localStorage.getItem(STORAGE_KEYS.ABSENCES)) {
        const todayYear = new Date().getFullYear();
        const defaultAbsences = [
            { id: 'a-1', userId: 'u-2', type: 'Urlaub', startDate: \`\${todayYear}-07-10\`, endDate: \`\${todayYear}-07-20\`, daysCount: 7, status: 'Genehmigt' },
            { id: 'a-2', userId: 'u-3', type: 'Krankheit', startDate: \`\${todayYear}-03-02\`, endDate: \`\${todayYear}-03-04\`, daysCount: 3, status: 'Genehmigt' },
            { id: 'a-3', userId: 'u-3', type: 'Urlaub', startDate: \`\${todayYear}-08-15\`, endDate: \`\${todayYear}-08-25\`, daysCount: 8, status: 'Genehmigt' }
        ];
        db.saveAbsences(defaultAbsences);
    }

    if (!localStorage.getItem(STORAGE_KEYS.LOGS)) {
        const todayYear = new Date().getFullYear();
        const defaultLogs = [
            {
                id: 'log-1',
                timestamp: new Date().toISOString(),
                userId: 'u-2',
                userName: 'Max Mustermann',
                category: 'Urlaub',
                action: 'Erstellt',
                description: \`Urlaubsantrag vom 10.07.\${todayYear} bis 20.07.\${todayYear} (7 Tage) eingereicht\`
            },
            {
                id: 'log-2',
                timestamp: new Date().toISOString(),
                userId: 'u-1',
                userName: 'Administrator',
                category: 'Urlaub',
                action: 'Genehmigt',
                description: \`Urlaubsantrag von Max Mustermann genehmigt\`
            }
        ];
        db.saveLogs(defaultLogs);
    }
};

window.showToast = function(message, type = 'info') {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    const bgColors = {
        success: 'bg-emerald-600 text-white',
        error: 'bg-rose-600 text-white',
        info: 'bg-slate-800 text-white'
    };

    toast.className = \`p-4 rounded-xl shadow-lg text-sm font-medium transition-all transform translate-y-2 opacity-0 flex items-center gap-3 pointer-events-auto \${bgColors[type] || bgColors.info}\`;
    toast.innerHTML = \`
        <i class="fa-solid \${type === 'success' ? 'fa-check-circle' : type === 'error' ? 'fa-triangle-exclamation' : 'fa-info-circle'} text-lg"></i>
        <span class="flex-1">\${message}</span>
    \`;

    container.appendChild(toast);
    setTimeout(() => toast.classList.remove('translate-y-2', 'opacity-0'), 10);
    setTimeout(() => {
        toast.classList.add('opacity-0', 'translate-y-2');
        setTimeout(() => toast.remove(), 300);
    }, 3500);
};

window.calculateNetHours = function(start, end) {
    if (!start || !end) return 0;
    const [sH, sM] = start.split(':').map(Number);
    const [eH, eM] = end.split(':').map(Number);
    const diff = (eH * 60 + eM) - (sH * 60 + sM);
    return diff > 0 ? diff / 60 : 0;
};

window.calculateDaysCount = function(startDate, endDate) {
    if (!startDate || !endDate) return 0;
    const s = new Date(startDate);
    const e = new Date(endDate);
    let count = 0;
    let cur = new Date(s);
    while (cur <= e) {
        const day = cur.getDay();
        if (day !== 0 && day !== 6) count++;
        cur.setDate(cur.getDate() + 1);
    }
    return count > 0 ? count : 1;
};

window.handleLogin = function(e) {
    if (e) e.preventDefault();
    const usernameInput = document.getElementById('login-username').value.trim();
    const passwordInput = document.getElementById('login-password').value.trim();

    const users = db.getUsers();
    const foundUser = users.find(u => u.username.toLowerCase() === usernameInput.toLowerCase() && u.password === passwordInput);

    if (foundUser) {
        currentUser = foundUser;
        db.setCurrentUser(foundUser);
        startSession();
        showToast(\`Willkommen zurück, \${foundUser.name}!\`, 'success');
    } else {
        showToast('Ungültiger Benutzername oder Passwort', 'error');
    }
};



window.logout = function() {
    currentUser = null;
    db.setCurrentUser(null);
    document.getElementById('app-view').classList.add('hidden');
    document.getElementById('login-view').classList.remove('hidden');
    showToast('Erfolgreich abgemeldet', 'info');
};

window.startSession = function() {
    document.getElementById('login-view').classList.add('hidden');
    document.getElementById('app-view').classList.remove('hidden');

    document.getElementById('header-user-name').textContent = currentUser.name;
    document.getElementById('header-user-username').textContent = \`@\${currentUser.username}\`;
    document.getElementById('user-role-badge').textContent = currentUser.role === 'admin' ? 'Administrator' : 'Mitarbeiter';

    if (currentUser.role === 'admin') {
        document.getElementById('section-admin').classList.remove('hidden');
        document.getElementById('section-employee').classList.add('hidden');
        loadAdminDashboard();
    } else {
        document.getElementById('section-employee').classList.remove('hidden');
        document.getElementById('section-admin').classList.add('hidden');
        loadEmployeeDashboard();
    }
};

window.loadEmployeeDashboard = function() {
    document.getElementById('emp-welcome').textContent = \`Willkommen zurück, \${currentUser.name.split(' ')[0]}!\`;

    const now = new Date();
    const currentMonth = \`\${now.getFullYear()}-\${String(now.getMonth() + 1).padStart(2, '0')}\`;
    
    const filterInput = document.getElementById('emp-filter-month');
    if (filterInput && !filterInput.value) {
        filterInput.value = currentMonth;
    }

    const hours = db.getHours().filter(h => h.userId === currentUser.id);
    const monthHours = hours
        .filter(h => h.date.startsWith(filterInput.value || currentMonth))
        .reduce((acc, h) => acc + calculateNetHours(h.start, h.end), 0);

    document.getElementById('stat-emp-month-hours').textContent = \`\${monthHours.toFixed(2)} h\`;

    const absences = db.getAbsences().filter(a => a.userId === currentUser.id);
    const usedVacation = absences
        .filter(a => a.type === 'Urlaub' && a.status === 'Genehmigt')
        .reduce((acc, a) => acc + a.daysCount, 0);

    const totalVacation = currentUser.vacationQuota || 30;
    const remainingVacation = Math.max(0, totalVacation - usedVacation);

    document.getElementById('stat-emp-vacation-remaining').textContent = \`\${remainingVacation} Tage\`;
    document.getElementById('stat-emp-vacation-total').textContent = \`von \${totalVacation} Tagen Anspruch\`;

    const sickDays = absences
        .filter(a => a.type === 'Krankheit')
        .reduce((acc, a) => acc + a.daysCount, 0);

    document.getElementById('stat-emp-sick-days').textContent = \`\${sickDays} Tage\`;

    renderEmpHoursTable();
    renderEmpAbsencesTable();
    renderEmpCharts();
};

window.switchEmpTab = function(tabName) {
    const tabs = ['hours', 'absences', 'yearly'];
    tabs.forEach(t => {
        const btn = document.getElementById(\`emp-tab-\${t}\`);
        const sub = document.getElementById(\`emp-sub-\${t}\`);
        if (t === tabName) {
            btn.className = 'pb-4 border-b-2 border-brand-600 text-brand-600 font-semibold flex items-center gap-2';
            sub.classList.remove('hidden');
        } else {
            btn.className = 'pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2';
            sub.classList.add('hidden');
        }
    });
};

window.renderEmpHoursTable = function() {
    const tbody = document.getElementById('emp-hours-tbody');
    const filterMonth = document.getElementById('emp-filter-month').value;
    if (!tbody || !currentUser) return;

    const hours = db.getHours()
        .filter(h => h.userId === currentUser.id && h.date.startsWith(filterMonth))
        .sort((a,b) => b.date.localeCompare(a.date));

    if (hours.length === 0) {
        tbody.innerHTML = \`<tr><td colspan="4" class="text-center py-8 text-slate-400">Keine Zeiteinträge für diesen Monat vorhanden.</td></tr>\`;
        return;
    }

    tbody.innerHTML = hours.map(h => {
        const netHours = calculateNetHours(h.start, h.end);
        const formattedDate = new Date(h.date).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });

        return \`
            <tr class="hover:bg-slate-50 transition">
                <td class="px-4 py-3 font-medium text-slate-800">\${formattedDate}</td>
                <td class="px-4 py-3">\${h.start} - \${h.end} Uhr</td>
                <td class="px-4 py-3 font-semibold text-brand-700">\${netHours.toFixed(2)} h</td>
                <td class="px-4 py-3 text-right">
                    <button onclick="editTimeEntry('\${h.id}')" class="p-1.5 text-slate-400 hover:text-brand-600 rounded-lg hover:bg-slate-100" title="Bearbeiten"><i class="fa-solid fa-pen-to-square"></i></button>
                    <button onclick="deleteTimeEntry('\${h.id}')" class="p-1.5 text-slate-400 hover:text-rose-600 rounded-lg hover:bg-slate-100" title="Löschen"><i class="fa-solid fa-trash-can"></i></button>
                </td>
            </tr>
        \`;
    }).join('');
};

window.renderEmpAbsencesTable = function() {
    const tbody = document.getElementById('emp-absences-tbody');
    if (!tbody || !currentUser) return;

    const absences = db.getAbsences()
        .filter(a => a.userId === currentUser.id)
        .sort((a,b) => b.startDate.localeCompare(a.startDate));

    if (absences.length === 0) {
        tbody.innerHTML = \`<tr><td colspan="5" class="text-center py-8 text-slate-400">Keine Abwesenheitsanträge vorhanden.</td></tr>\`;
        return;
    }

    tbody.innerHTML = absences.map(a => {
        const startStr = new Date(a.startDate).toLocaleDateString('de-DE');
        const endStr = new Date(a.endDate).toLocaleDateString('de-DE');

        let statusBadge = '';
        if (a.status === 'Genehmigt') {
            statusBadge = \`<span class="bg-emerald-100 text-emerald-800 text-xs px-2.5 py-1 rounded-full font-medium">Genehmigt</span>\`;
        } else if (a.status === 'Abgelehnt') {
            statusBadge = \`<span class="bg-rose-100 text-rose-800 text-xs px-2.5 py-1 rounded-full font-medium">Abgelehnt</span>\`;
        } else {
            statusBadge = \`<span class="bg-amber-100 text-amber-800 text-xs px-2.5 py-1 rounded-full font-medium">Beantragt</span>\`;
        }

        const typeBadge = a.type === 'Urlaub'
            ? \`<span class="text-indigo-600 font-semibold"><i class="fa-solid fa-umbrella-beach mr-1"></i>Urlaub</span>\`
            : \`<span class="text-rose-600 font-semibold"><i class="fa-solid fa-bed mr-1"></i>Krankheit</span>\`;

        return \`
            <tr class="hover:bg-slate-50 transition">
                <td class="px-4 py-3">\${typeBadge}</td>
                <td class="px-4 py-3 font-medium text-slate-700">\${startStr} - \${endStr}</td>
                <td class="px-4 py-3 font-semibold text-slate-800">\${a.daysCount} Tage</td>
                <td class="px-4 py-3">\${statusBadge}</td>
                <td class="px-4 py-3 text-right space-x-1">
                    <button onclick="editAbsenceEntry('\${a.id}')" class="p-1.5 text-slate-400 hover:text-indigo-600 rounded-lg hover:bg-slate-100" title="Bearbeiten"><i class="fa-solid fa-pen-to-square"></i></button>
                    <button onclick="deleteAbsence('\${a.id}')" class="p-1.5 text-slate-400 hover:text-rose-600 rounded-lg hover:bg-slate-100" title="Stornieren / Löschen"><i class="fa-solid fa-trash-can"></i></button>
                </td>
            </tr>
        \`;
    }).join('');
};

window.renderEmpCharts = function() {
    const ctxHours = document.getElementById('chart-emp-hours');
    const ctxVacation = document.getElementById('chart-emp-vacation');
    if (!ctxHours || !ctxVacation) return;

    if (chartHoursInstance) chartHoursInstance.destroy();
    if (chartVacationInstance) chartVacationInstance.destroy();

    const hours = db.getHours().filter(h => h.userId === currentUser.id);
    const months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
    const currentYear = new Date().getFullYear();

    const monthlyData = new Array(12).fill(0);
    hours.forEach(h => {
        const d = new Date(h.date);
        if (d.getFullYear() === currentYear) {
            monthlyData[d.getMonth()] += calculateNetHours(h.start, h.end);
        }
    });

    chartHoursInstance = new Chart(ctxHours, {
        type: 'bar',
        data: {
            labels: months,
            datasets: [{
                label: 'Arbeitsstunden (h)',
                data: monthlyData,
                backgroundColor: '#0284c7',
                borderRadius: 6
            }]
        },
        options: { responsive: true, maintainAspectRatio: false }
    });

    const absences = db.getAbsences().filter(a => a.userId === currentUser.id && a.status === 'Genehmigt');
    const vacationDays = absences.filter(a => a.type === 'Urlaub').reduce((acc, a) => acc + a.daysCount, 0);
    const sickDays = absences.filter(a => a.type === 'Krankheit').reduce((acc, a) => acc + a.daysCount, 0);

    chartVacationInstance = new Chart(ctxVacation, {
        type: 'doughnut',
        data: {
            labels: ['Urlaub Genutzt', 'Krankheitstage', 'Resturlaub'],
            datasets: [{
                data: [vacationDays, sickDays, Math.max(0, (currentUser.vacationQuota || 30) - vacationDays)],
                backgroundColor: ['#6366f1', '#f43f5e', '#e2e8f0']
            }]
        },
        options: { responsive: true, maintainAspectRatio: false }
    });
};

window.loadAdminDashboard = function() {
    const users = db.getUsers();
    const hours = db.getHours();
    const absences = db.getAbsences();

    document.getElementById('stat-admin-users-count').textContent = users.length;

    const now = new Date();
    const currentMonth = \`\${now.getFullYear()}-\${String(now.getMonth() + 1).padStart(2, '0')}\`;
    const totalMonthHours = hours
        .filter(h => h.date.startsWith(currentMonth))
        .reduce((acc, h) => acc + calculateNetHours(h.start, h.end), 0);

    document.getElementById('stat-admin-total-hours').textContent = \`\${totalMonthHours.toFixed(2)} h\`;

    const pendingVacations = absences.filter(a => a.type === 'Urlaub' && a.status === 'Beantragt').length;
    document.getElementById('stat-admin-pending-vacations').textContent = \`\${pendingVacations} Offen\`;

    const sickCount = absences.filter(a => a.type === 'Krankheit').length;
    document.getElementById('stat-admin-sick-count').textContent = sickCount;

    populateAdminFilterUsers();
    renderAdminUsersTable();
    renderAdminHoursTable();
    renderAdminAbsencesTable();
    renderAdminLogsTable();
    renderVacationCalendar('admin-vacation-calendar-container');
};

window.switchAdminTab = function(tabName) {
    const tabs = ['users', 'calendar', 'all-hours', 'all-absences', 'logs'];
    tabs.forEach(t => {
        const btn = document.getElementById(\`admin-tab-\${t}\`);
        const sub = document.getElementById(\`admin-sub-\${t}\`);
        if (t === tabName) {
            btn.className = 'pb-4 border-b-2 border-brand-600 text-brand-600 font-semibold flex items-center gap-2';
            sub.classList.remove('hidden');
        } else {
            btn.className = 'pb-4 border-b-2 border-transparent text-slate-500 hover:text-slate-800 flex items-center gap-2';
            sub.classList.add('hidden');
        }
    });

    if (tabName === 'calendar') {
        renderVacationCalendar('admin-vacation-calendar-container');
    } else if (tabName === 'logs') {
        renderAdminLogsTable();
    }
};

window.populateAdminFilterUsers = function() {
    const select = document.getElementById('admin-filter-user');
    const logSelect = document.getElementById('log-filter-user');
    const users = db.getUsers();

    if (select) {
        const currentValue = select.value;
        select.innerHTML = \`<option value="ALL">Alle Mitarbeiter</option>\` + 
            users.map(u => \`<option value="\${u.id}">\${u.name}</option>\`).join('');
        select.value = currentValue || 'ALL';
    }

    if (logSelect) {
        const currentLogVal = logSelect.value;
        logSelect.innerHTML = \`<option value="ALL">Alle Mitarbeiter</option>\` + 
            users.map(u => \`<option value="\${u.id}">\${u.name}</option>\`).join('');
        logSelect.value = currentLogVal || 'ALL';
    }
};

window.renderAdminUsersTable = function() {
    const tbody = document.getElementById('admin-users-tbody');
    if (!tbody) return;

    const users = db.getUsers();
    const absences = db.getAbsences();
    const currentYear = new Date().getFullYear();

    tbody.innerHTML = users.map(u => {
        const totalVacation = parseInt(u.vacationQuota) || 30;
        const usedVacation = absences
            .filter(a => a.userId === u.id && a.type === 'Urlaub' && a.status === 'Genehmigt')
            .filter(a => {
                const date = a.startDate || a.date;
                return date && String(date).startsWith(String(currentYear));
            })
            .reduce((acc, a) => acc + (parseFloat(a.daysCount) || 0), 0);

        const remainingVacation = Math.max(0, totalVacation - usedVacation);
        const remainingClass = remainingVacation <= 5 ? 'text-rose-600' : remainingVacation <= 10 ? 'text-amber-600' : 'text-emerald-700';

        return \`
        <tr class="hover:bg-slate-50 transition">
            <td class="px-4 py-3 font-semibold text-slate-800">\${u.name}</td>
            <td class="px-4 py-3 text-slate-600">@\${u.username}</td>
            <td class="px-4 py-3"><span class="px-2.5 py-1 rounded-full text-xs font-semibold \${u.role === 'admin' ? 'bg-purple-100 text-purple-800' : 'bg-slate-100 text-slate-700'}">\${u.role === 'admin' ? 'Admin' : 'Mitarbeiter'}</span></td>
            <td class="px-4 py-3 font-medium text-emerald-700">\${(parseFloat(u.hourlyRate) || 0).toFixed(2)} €/h</td>
            <td class="px-4 py-3 text-slate-700 font-medium">\${totalVacation} Tage</td>
            <td class="px-4 py-3 text-slate-700 font-medium">\${usedVacation} Tage</td>
            <td class="px-4 py-3 font-bold \${remainingClass}">\${remainingVacation} Tage</td>
            <td class="px-4 py-3 text-right">
                <button onclick="editUser('\${u.id}')" class="p-1.5 text-slate-400 hover:text-brand-600 rounded-lg hover:bg-slate-100" title="Bearbeiten"><i class="fa-solid fa-user-pen"></i></button>
                <button onclick="deleteUser('\${u.id}')" class="p-1.5 text-slate-400 hover:text-rose-600 rounded-lg hover:bg-slate-100" title="Mitarbeiter löschen"><i class="fa-solid fa-trash-can"></i></button>
            </td>
        </tr>
    \`}).join('');
};

window.renderAdminHoursTable = function() {
    const tbody = document.getElementById('admin-hours-tbody');
    const summaryTbody = document.getElementById('admin-monthly-summary-tbody');
    const filterUser = document.getElementById('admin-filter-user') ? document.getElementById('admin-filter-user').value : 'ALL';
    const filterMonth = document.getElementById('admin-filter-month') ? document.getElementById('admin-filter-month').value : '';

    const allHours = db.getHours();
    const users = db.getUsers();

    const summaryMap = {};
    allHours.forEach(h => {
        const monthKey = h.date.substring(0, 7);
        const key = \`\${h.userId}_\${monthKey}\`;
        if (!summaryMap[key]) {
            summaryMap[key] = { userId: h.userId, month: monthKey, totalHours: 0, count: 0 };
        }
        summaryMap[key].totalHours += calculateNetHours(h.start, h.end);
        summaryMap[key].count += 1;
    });

    const sortedSummaries = Object.values(summaryMap).sort((a, b) => b.month.localeCompare(a.month));

    if (summaryTbody) {
        if (sortedSummaries.length === 0) {
            summaryTbody.innerHTML = \`<tr><td colspan="5" class="text-center py-4 text-slate-400">Keine Daten vorhanden</td></tr>\`;
        } else {
            summaryTbody.innerHTML = sortedSummaries.map(s => {
                const u = users.find(usr => usr.id === s.userId) || { name: 'Unbekannt', hourlyRate: 0 };
                const rate = parseFloat(u.hourlyRate) || 0;
                const earnings = s.totalHours * rate;
                const monthName = new Date(s.month + '-01').toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });
                return \`
                    <tr class="hover:bg-slate-100/50 transition">
                        <td class="px-3 py-2 font-semibold text-slate-800">\${u.name}</td>
                        <td class="px-3 py-2 text-slate-600">\${monthName}</td>
                        <td class="px-3 py-2 text-slate-600">\${s.count} Einträge</td>
                        <td class="px-3 py-2 font-bold text-brand-700">\${s.totalHours.toFixed(2)} h</td>
                        <td class="px-3 py-2 text-right font-bold text-emerald-700">\${earnings.toFixed(2)} € <span class="text-[10px] text-slate-400 font-normal">(\${rate.toFixed(2)} €/h)</span></td>
                    </tr>
                \`;
            }).join('');
        }
    }

    let filteredHours = allHours;
    if (filterUser !== 'ALL') {
        filteredHours = filteredHours.filter(h => h.userId === filterUser);
    }
    if (filterMonth) {
        filteredHours = filteredHours.filter(h => h.date.startsWith(filterMonth));
    }

    filteredHours.sort((a,b) => b.date.localeCompare(a.date));

    if (!tbody) return;

    if (filteredHours.length === 0) {
        tbody.innerHTML = \`<tr><td colspan="6" class="text-center py-8 text-slate-400">Keine Zeiteinträge gefunden.</td></tr>\`;
        return;
    }

    tbody.innerHTML = filteredHours.map(h => {
        const u = users.find(usr => usr.id === h.userId) || { name: 'Unbekannt' };
        const netHours = calculateNetHours(h.start, h.end);
        const formattedDate = new Date(h.date).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
        
        const hasHistory = h.editHistory && h.editHistory.length > 0;
        const editedBadge = (h.isEdited || hasHistory) ? \`
            <button onclick="showAuditLog('\${h.id}')" title="Klicken für Änderungshistorie (Admin)" class="ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-amber-100 hover:bg-amber-200 text-amber-800 text-xs font-semibold cursor-pointer border border-amber-300 transition">
                <i class="fa-solid fa-clock-rotate-left text-[10px]"></i> (Geändert)
            </button>
        \` : '';

        return \`
            <tr class="hover:bg-slate-50 transition">
                <td class="px-4 py-3 font-semibold text-slate-800">\${u.name}</td>
                <td class="px-4 py-3 font-medium text-slate-700">\${formattedDate}\${editedBadge}</td>
                <td class="px-4 py-3 text-slate-600">\${h.start} - \${h.end} Uhr</td>
                <td class="px-4 py-3 font-bold text-brand-700">\${netHours.toFixed(2)} h</td>
                <td class="px-4 py-3"><span class="text-xs bg-slate-100 text-slate-700 px-2.5 py-1 rounded-full font-medium">Erfasst</span></td>
                <td class="px-4 py-3 text-right">
                    <button onclick="editTimeEntry('\${h.id}')" class="p-1.5 text-slate-400 hover:text-brand-600 rounded-lg hover:bg-slate-100" title="Bearbeiten"><i class="fa-solid fa-pen-to-square"></i></button>
                    <button onclick="deleteTimeEntry('\${h.id}')" class="p-1.5 text-slate-400 hover:text-rose-600 rounded-lg hover:bg-slate-100" title="Löschen"><i class="fa-solid fa-trash-can"></i></button>
                </td>
            </tr>
        \`;
    }).join('');
};

window.renderAdminAbsencesTable = function() {
    const tbody = document.getElementById('admin-absences-tbody');
    if (!tbody) return;

    const absences = db.getAbsences().sort((a,b) => b.startDate.localeCompare(a.startDate));
    const users = db.getUsers();

    if (absences.length === 0) {
        tbody.innerHTML = \`<tr><td colspan="6" class="text-center py-8 text-slate-400">Keine Abwesenheitseinträge vorhanden.</td></tr>\`;
        return;
    }

    tbody.innerHTML = absences.map(a => {
        const u = users.find(usr => usr.id === a.userId) || { name: 'Unbekannt' };
        const startStr = new Date(a.startDate).toLocaleDateString('de-DE');
        const endStr = new Date(a.endDate).toLocaleDateString('de-DE');

        let statusBadge = '';
        if (a.status === 'Genehmigt') {
            statusBadge = \`<span class="bg-emerald-100 text-emerald-800 text-xs px-2.5 py-1 rounded-full font-medium">Genehmigt</span>\`;
        } else if (a.status === 'Abgelehnt') {
            statusBadge = \`<span class="bg-rose-100 text-rose-800 text-xs px-2.5 py-1 rounded-full font-medium">Abgelehnt</span>\`;
        } else {
            statusBadge = \`<span class="bg-amber-100 text-amber-800 text-xs px-2.5 py-1 rounded-full font-medium">Beantragt</span>\`;
        }

        const typeBadge = a.type === 'Urlaub'
            ? \`<span class="text-indigo-600 font-semibold"><i class="fa-solid fa-umbrella-beach mr-1"></i>Urlaub</span>\`
            : \`<span class="text-rose-600 font-semibold"><i class="fa-solid fa-bed mr-1"></i>Krankheit</span>\`;

        return \`
            <tr class="hover:bg-slate-50 transition">
                <td class="px-4 py-3 font-semibold text-slate-800">\${u.name}</td>
                <td class="px-4 py-3">\${typeBadge}</td>
                <td class="px-4 py-3 font-medium text-slate-700">\${startStr} - \${endStr}</td>
                <td class="px-4 py-3 font-semibold text-slate-800">\${a.daysCount} Tage</td>
                <td class="px-4 py-3">\${statusBadge}</td>
                <td class="px-4 py-3 text-right space-x-1">
                    \${a.status === 'Beantragt' ? \`
                        <button onclick="approveAbsence('\${a.id}')" class="px-2.5 py-1 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-xs font-medium" title="Genehmigen"><i class="fa-solid fa-check mr-1"></i>Genehmigen</button>
                        <button onclick="rejectAbsence('\${a.id}')" class="px-2.5 py-1 bg-rose-600 hover:bg-rose-700 text-white rounded-lg text-xs font-medium" title="Ablehnen"><i class="fa-solid fa-xmark mr-1"></i>Ablehnen</button>
                    \` : ''}
                    <button onclick="editAbsenceEntry('\${a.id}')" class="p-1.5 text-slate-400 hover:text-indigo-600 rounded-lg hover:bg-slate-100" title="Bearbeiten"><i class="fa-solid fa-pen-to-square"></i></button>
                    <button onclick="deleteAdminAbsence('\${a.id}')" class="p-1.5 text-slate-400 hover:text-rose-600 rounded-lg hover:bg-slate-100" title="Löschen"><i class="fa-solid fa-trash-can"></i></button>
                </td>
            </tr>
        \`;
    }).join('');
};

window.renderAdminLogsTable = function() {
    const tbody = document.getElementById('admin-logs-tbody');
    if (!tbody) return;

    let logs = db.getLogs();
    const filterUser = document.getElementById('log-filter-user') ? document.getElementById('log-filter-user').value : 'ALL';
    const filterCat = document.getElementById('log-filter-category') ? document.getElementById('log-filter-category').value : 'ALL';
    const filterAct = document.getElementById('log-filter-action') ? document.getElementById('log-filter-action').value : 'ALL';

    if (filterUser !== 'ALL') {
        logs = logs.filter(l => l.userId === filterUser);
    }
    if (filterCat !== 'ALL') {
        logs = logs.filter(l => l.category === filterCat);
    }
    if (filterAct !== 'ALL') {
        logs = logs.filter(l => l.action === filterAct);
    }

    if (logs.length === 0) {
        tbody.innerHTML = \`<tr><td colspan="5" class="text-center py-8 text-slate-400">Keine Protokolleinträge gefunden.</td></tr>\`;
        return;
    }

    tbody.innerHTML = logs.map(l => {
        const timeFormatted = new Date(l.timestamp).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

        let actionBadge = 'bg-slate-100 text-slate-700';
        if (l.action === 'Erstellt') actionBadge = 'bg-blue-100 text-blue-800 border-blue-200';
        else if (l.action === 'Geändert') actionBadge = 'bg-amber-100 text-amber-800 border-amber-200';
        else if (l.action === 'Genehmigt') actionBadge = 'bg-emerald-100 text-emerald-800 border-emerald-200';
        else if (l.action === 'Abgelehnt' || l.action === 'Gelöscht') actionBadge = 'bg-rose-100 text-rose-800 border-rose-200';

        let categoryBadge = 'text-slate-600';
        if (l.category === 'Urlaub') categoryBadge = 'text-indigo-600 font-semibold';
        else if (l.category === 'Krankheit') categoryBadge = 'text-rose-600 font-semibold';
        else if (l.category === 'Arbeitszeit') categoryBadge = 'text-brand-600 font-semibold';

        return \`
            <tr class="hover:bg-slate-50 transition text-xs">
                <td class="px-4 py-3 font-medium text-slate-500 whitespace-nowrap">\${timeFormatted}</td>
                <td class="px-4 py-3 font-semibold text-slate-800">\${l.userName}</td>
                <td class="px-4 py-3 \${categoryBadge}">\${l.category}</td>
                <td class="px-4 py-3"><span class="px-2.5 py-1 rounded-md text-[11px] font-semibold border \${actionBadge}">\${l.action}</span></td>
                <td class="px-4 py-3 text-slate-700 font-medium">\${l.description}</td>
            </tr>
        \`;
    }).join('');
};

window.setCalendarViewMode = function(mode, containerId) {
    calViewMode = mode;
    renderVacationCalendar(containerId);
};

window.changeCalendarMonth = function(offset, containerId) {
    const [year, month] = calYearMonth.split('-').map(Number);
    const date = new Date(year, month - 1 + offset, 1);
    const newY = date.getFullYear();
    const newM = String(date.getMonth() + 1).padStart(2, '0');
    calYearMonth = \`\${newY}-\${newM}\`;
    renderVacationCalendar(containerId);
};

window.onCalendarMonthInputChange = function(val, containerId) {
    if (val) {
        calYearMonth = val;
        renderVacationCalendar(containerId);
    }
};

window.onCalendarFilterChange = function(val, containerId) {
    calFilterType = val;
    renderVacationCalendar(containerId);
};

window.renderVacationCalendar = function(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const [yearStr, monthStr] = calYearMonth.split('-');
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10);

    const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    const currentMonthLabel = \`\${monthNames[month - 1]} \${year}\`;

    const users = db.getUsers();
    let absences = db.getAbsences();

    if (calFilterType !== 'ALL') {
        absences = absences.filter(a => a.type === calFilterType);
    }

    let html = \`
        <div class="bg-slate-50 border border-slate-200 rounded-2xl p-4 mb-5 shadow-sm flex flex-col md:flex-row items-center justify-between gap-4">
            <div class="flex items-center gap-3">
                <button onclick="changeCalendarMonth(-1, '\${containerId}')" class="p-2 bg-white border border-slate-300 hover:bg-slate-100 rounded-xl transition text-slate-700" title="Vorheriger Monat">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
                <div class="flex items-center gap-2">
                    <h3 class="text-lg font-bold text-slate-800 min-w-[150px] text-center">\${currentMonthLabel}</h3>
                    <input type="month" value="\${calYearMonth}" onchange="onCalendarMonthInputChange(this.value, '\${containerId}')" class="px-2 py-1 bg-white border border-slate-300 rounded-lg text-xs">
                </div>
                <button onclick="changeCalendarMonth(1, '\${containerId}')" class="p-2 bg-white border border-slate-300 hover:bg-slate-100 rounded-xl transition text-slate-700" title="Nächster Monat">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
            </div>

            <div class="flex flex-wrap items-center gap-3">
                <div class="flex items-center gap-1.5 bg-slate-200/80 p-1 rounded-xl">
                    <button onclick="setCalendarViewMode('grid', '\${containerId}')" class="px-3 py-1.5 rounded-lg text-xs font-semibold transition \${calViewMode === 'grid' ? 'bg-white shadow text-slate-900' : 'text-slate-600 hover:text-slate-900'}">
                        <i class="fa-solid fa-calendar-grid mr-1.5"></i> Monatsraster
                    </button>
                    <button onclick="setCalendarViewMode('timeline', '\${containerId}')" class="px-3 py-1.5 rounded-lg text-xs font-semibold transition \${calViewMode === 'timeline' ? 'bg-white shadow text-slate-900' : 'text-slate-600 hover:text-slate-900'}">
                        <i class="fa-solid fa-bars-progress mr-1.5"></i> Team-Timeline
                    </button>
                </div>

                <select onchange="onCalendarFilterChange(this.value, '\${containerId}')" class="px-3 py-1.5 bg-white border border-slate-300 rounded-xl text-xs font-medium focus:outline-none">
                    <option value="ALL" \${calFilterType === 'ALL' ? 'selected' : ''}>Alle Abwesenheiten</option>
                    <option value="Urlaub" \${calFilterType === 'Urlaub' ? 'selected' : ''}>Nur Urlaub</option>
                    <option value="Krankheit" \${calFilterType === 'Krankheit' ? 'selected' : ''}>Nur Krankmeldungen</option>
                </select>
            </div>
        </div>
    \`;

    if (calViewMode === 'grid') {
        html += renderGridCalendar(year, month, users, absences);
    } else {
        html += renderTimelineCalendar(year, month, users, absences);
    }

    container.innerHTML = html;
};

function renderGridCalendar(year, month, users, absences) {
    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDayOfWeek = new Date(year, month - 1, 1).getDay();
    const adjustedFirstDay = (firstDayOfWeek + 6) % 7;

    const weekdays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

    let html = \`
        <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
            <div class="grid grid-cols-7 border-b border-slate-200 bg-slate-100 text-center text-xs font-bold text-slate-600 py-2.5">
                \${weekdays.map((w, idx) => \`<div class="\${idx >= 5 ? 'text-rose-500' : ''}">\${w}</div>\`).join('')}
            </div>
            <div class="grid grid-cols-7 auto-rows-fr divide-x divide-y divide-slate-200 bg-slate-50">
    \`;

    for (let i = 0; i < adjustedFirstDay; i++) {
        html += \`<div class="min-h-[100px] bg-slate-100/50"></div>\`;
    }

    const todayStr = new Date().toISOString().split('T')[0];

    for (let day = 1; day <= daysInMonth; day++) {
        const curDateStr = \`\${year}-\${String(month).padStart(2, '0')}-\${String(day).padStart(2, '0')}\`;
        const curDateObj = new Date(year, month - 1, day);
        const dayOfWeek = curDateObj.getDay();
        const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6);
        const isToday = curDateStr === todayStr;

        const activeAbsences = absences.filter(a => {
            return curDateStr >= a.startDate && curDateStr <= a.endDate && a.status !== 'Abgelehnt';
        });

        html += \`
            <div class="min-h-[110px] p-2 flex flex-col justify-start transition \${isWeekend ? 'bg-slate-100/70' : 'bg-white'} \${isToday ? 'ring-2 ring-brand-500 ring-inset' : ''}">
                <div class="flex justify-between items-center mb-1.5">
                    <span class="text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center \${isToday ? 'bg-brand-600 text-white' : isWeekend ? 'text-slate-400' : 'text-slate-700'}">\${day}</span>
                    \${activeAbsences.length > 0 ? \`<span class="text-[10px] font-semibold text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded-md border border-indigo-200">\${activeAbsences.length} abwesend</span>\` : ''}
                </div>
                <div class="space-y-1 overflow-y-auto max-h-[80px] custom-scrollbar">
        \`;

        activeAbsences.forEach(a => {
            const u = users.find(usr => usr.id === a.userId) || { name: 'Mitarbeiter' };
            const firstName = u.name.split(' ')[0];

            let bgClass = 'bg-indigo-100 text-indigo-800 border-indigo-200';
            let icon = 'fa-umbrella-beach';

            if (a.type === 'Krankheit') {
                bgClass = 'bg-rose-100 text-rose-800 border-rose-200';
                icon = 'fa-bed';
            } else if (a.status === 'Beantragt') {
                bgClass = 'bg-amber-100 text-amber-800 border-amber-200';
                icon = 'fa-clock';
            }

            html += \`
                <div class="text-[11px] px-1.5 py-1 rounded-md border \${bgClass} font-medium flex items-center gap-1 shadow-2xs truncate" title="\${u.name} (\${a.type} - \${a.status})">
                    <i class="fa-solid \${icon} text-[10px] shrink-0"></i>
                    <span class="truncate">\${firstName}</span>
                </div>
            \`;
        });

        html += \`
                </div>
            </div>
        \`;
    }

    const totalCells = adjustedFirstDay + daysInMonth;
    const remainingCells = (7 - (totalCells % 7)) % 7;
    for (let i = 0; i < remainingCells; i++) {
        html += \`<div class="min-h-[100px] bg-slate-100/50"></div>\`;
    }

    html += \`
            </div>
        </div>
        <div class="flex flex-wrap items-center gap-4 text-xs text-slate-500 pt-2">
            <div class="flex items-center gap-1.5"><span class="w-3 h-3 rounded bg-indigo-100 border border-indigo-300"></span> Urlaub (Genehmigt)</div>
            <div class="flex items-center gap-1.5"><span class="w-3 h-3 rounded bg-amber-100 border border-amber-300"></span> Urlaub (Beantragt)</div>
            <div class="flex items-center gap-1.5"><span class="w-3 h-3 rounded bg-rose-100 border border-rose-300"></span> Krankheit</div>
        </div>
    \`;

    return html;
}

function renderTimelineCalendar(year, month, users, absences) {
    const daysInMonth = new Date(year, month, 0).getDate();

    let html = \`
        <div class="bg-white rounded-2xl border border-slate-200 overflow-x-auto custom-scrollbar shadow-sm">
            <table class="w-full border-collapse text-left text-xs">
                <thead>
                    <tr class="bg-slate-100 text-slate-700 border-b border-slate-200">
                        <th class="p-3 font-bold sticky left-0 bg-slate-100 min-w-[160px] border-r border-slate-200 shadow-sm z-10">Mitarbeiter</th>
    \`;

    for (let d = 1; d <= daysInMonth; d++) {
        const dateObj = new Date(year, month - 1, d);
        const dayOfWeek = dateObj.getDay();
        const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6);
        const weekdayShort = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'][dayOfWeek];

        html += \`
            <th class="p-2 text-center min-w-[36px] border-r border-slate-200/80 \${isWeekend ? 'bg-slate-200/60 font-semibold text-rose-600' : ''}">
                <div class="text-[10px] uppercase font-normal text-slate-400">\${weekdayShort}</div>
                <div>\${d}</div>
            </th>
        \`;
    }

    html += \`
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-200">
    \`;

    users.forEach(u => {
        const userAbsences = absences.filter(a => a.userId === u.id && a.status !== 'Abgelehnt');

        html += \`
            <tr class="hover:bg-slate-50 transition">
                <td class="p-3 font-semibold text-slate-800 sticky left-0 bg-white border-r border-slate-200 shadow-sm z-10 truncate max-w-[180px]">
                    \${u.name}
                </td>
        \`;

        for (let d = 1; d <= daysInMonth; d++) {
            const dateStr = \`\${year}-\${String(month).padStart(2, '0')}-\${String(d).padStart(2, '0')}\`;
            const dateObj = new Date(year, month - 1, d);
            const isWeekend = (dateObj.getDay() === 0 || dateObj.getDay() === 6);

            const activeAbs = userAbsences.find(a => dateStr >= a.startDate && dateStr <= a.endDate);

            let cellBg = isWeekend ? 'bg-slate-100/50' : '';
            let content = '';

            if (activeAbs) {
                if (activeAbs.type === 'Krankheit') {
                    cellBg = 'bg-rose-500 text-white font-bold';
                    content = '<i class="fa-solid fa-bed text-[10px]"></i>';
                } else if (activeAbs.status === 'Beantragt') {
                    cellBg = 'bg-amber-400 text-slate-900 font-bold';
                    content = '<i class="fa-solid fa-clock text-[10px]"></i>';
                } else {
                    cellBg = 'bg-indigo-600 text-white font-bold';
                    content = '<i class="fa-solid fa-umbrella-beach text-[10px]"></i>';
                }
            }

            html += \`
                <td class="p-1 text-center border-r border-slate-200/70 \${cellBg}" title="\${activeAbs ? \`\${u.name}: \${activeAbs.type} (\${activeAbs.status})\` : ''}">
                    \${content}
                </td>
            \`;
        }

        html += \`</tr>\`;
    });

    html += \`
                </tbody>
            </table>
        </div>
    \`;

    return html;
}

window.openTimeModal = function() {
    document.getElementById('form-time').reset();
    document.getElementById('time-entry-id').value = '';
    document.getElementById('modal-time-title').textContent = 'Arbeitszeit eintragen';
    document.getElementById('time-date').value = new Date().toISOString().split('T')[0];
    document.getElementById('time-start').value = '09:30';
    document.getElementById('time-end').value = '18:00';
    document.getElementById('modal-time').classList.remove('hidden');
};

window.editTimeEntry = function(id) {
    const hours = db.getHours();
    const entry = hours.find(h => h.id === id);
    if (!entry) return;

    document.getElementById('time-entry-id').value = entry.id;
    document.getElementById('time-date').value = entry.date;
    document.getElementById('time-start').value = entry.start;
    document.getElementById('time-end').value = entry.end;
    document.getElementById('modal-time-title').textContent = 'Arbeitszeit bearbeiten';
    document.getElementById('modal-time').classList.remove('hidden');
};

window.handleSaveTime = function(e) {
    e.preventDefault();
    const id = document.getElementById('time-entry-id').value;
    const date = document.getElementById('time-date').value;
    const start = document.getElementById('time-start').value;
    const end = document.getElementById('time-end').value;

    if (start >= end) {
        showToast('Die Startzeit muss vor der Endzeit liegen', 'error');
        return;
    }

    let hours = db.getHours();
    const targetUserId = id ? (hours.find(h => h.id === id)?.userId || currentUser.id) : currentUser.id;
    const targetUser = db.getUsers().find(u => u.id === targetUserId) || currentUser;

    const duplicateEntry = hours.find(h => h.userId === targetUserId && h.date === date && h.id !== id);
    if (duplicateEntry) {
        showToast('Für dieses Datum wurde bereits eine Arbeitszeit eingetragen!', 'error');
        return;
    }

    const netH = calculateNetHours(start, end);

    if (id) {
        const index = hours.findIndex(h => h.id === id);
        if (index !== -1) {
            const oldEntry = { ...hours[index] };
            const oldNetHours = calculateNetHours(oldEntry.start, oldEntry.end);

            const newEntry = {
                ...hours[index],
                date,
                start,
                end,
                isEdited: true
            };

            if (oldEntry.date !== date || oldEntry.start !== start || oldEntry.end !== end) {
                const historyRecord = {
                    modifiedBy: currentUser.name,
                    modifiedAt: new Date().toISOString(),
                    oldDate: oldEntry.date,
                    oldStart: oldEntry.start,
                    oldEnd: oldEntry.end,
                    oldNetHours: oldNetHours,
                    newDate: date,
                    newStart: start,
                    newEnd: end,
                    newNetHours: netH
                };
                newEntry.editHistory = newEntry.editHistory || [];
                newEntry.editHistory.push(historyRecord);
            }

            hours[index] = newEntry;

            logActivity(
                currentUser.id,
                currentUser.name,
                'Arbeitszeit',
                'Geändert',
                \`Arbeitszeit für \${targetUser.name} am \${date} geändert (\${start}-\${end} Uhr, \${netH.toFixed(2)} h)\`
            );

            showToast('Eintrag erfolgreich aktualisiert', 'success');
        }
    } else {
        const newEntry = {
            id: 'h-' + Date.now(),
            userId: currentUser.id,
            date,
            start,
            end,
            isEdited: false,
            editHistory: []
        };
        hours.push(newEntry);

        logActivity(
            currentUser.id,
            currentUser.name,
            'Arbeitszeit',
            'Erstellt',
            \`Arbeitszeit am \${date} von \${start} bis \${end} Uhr (\${netH.toFixed(2)} h) erfasst\`
        );

        showToast('Arbeitszeit erfolgreich eingetragen', 'success');
    }

    db.saveHours(hours);
    closeModal('modal-time');

    if (currentUser.role === 'admin') {
        loadAdminDashboard();
    } else {
        loadEmployeeDashboard();
    }
};

window.deleteTimeEntry = function(id) {
    let hours = db.getHours();
    const entry = hours.find(h => h.id === id);

    if (entry) {
        const targetUser = db.getUsers().find(u => u.id === entry.userId) || currentUser;
        logActivity(
            currentUser.id,
            currentUser.name,
            'Arbeitszeit',
            'Gelöscht',
            \`Arbeitszeit von \${targetUser.name} am \${entry.date} (\${entry.start}-\${entry.end} Uhr) gelöscht\`
        );
    }

    hours = hours.filter(h => h.id !== id);
    db.saveHours(hours);
    showToast('Zeiteintrag gelöscht', 'info');

    if (currentUser.role === 'admin') {
        loadAdminDashboard();
    } else {
        loadEmployeeDashboard();
    }
};

window.openAbsenceModal = function() {
    document.getElementById('form-absence').reset();
    document.getElementById('absence-entry-id').value = '';
    document.getElementById('modal-absence-title').textContent = 'Urlaub oder Krankheit eintragen';
    const today = new Date().toISOString().split('T')[0];
    document.getElementById('absence-start').value = today;
    document.getElementById('absence-end').value = today;
    document.getElementById('modal-absence').classList.remove('hidden');
};

window.editAbsenceEntry = function(id) {
    const absences = db.getAbsences();
    const entry = absences.find(a => a.id === id);
    if (!entry) return;

    document.getElementById('absence-entry-id').value = entry.id;
    document.getElementById('absence-type').value = entry.type;
    document.getElementById('absence-start').value = entry.startDate;
    document.getElementById('absence-end').value = entry.endDate;
    document.getElementById('modal-absence-title').textContent = 'Abwesenheitsantrag bearbeiten';
    document.getElementById('modal-absence').classList.remove('hidden');
};

window.handleSaveAbsence = function(e) {
    e.preventDefault();
    const id = document.getElementById('absence-entry-id').value;
    const type = document.getElementById('absence-type').value;
    const startDate = document.getElementById('absence-start').value;
    const endDate = document.getElementById('absence-end').value;

    if (startDate > endDate) {
        showToast('Das Startdatum muss vor oder auf dem Enddatum liegen', 'error');
        return;
    }

    const daysCount = calculateDaysCount(startDate, endDate);
    let absences = db.getAbsences();

    if (id) {
        const index = absences.findIndex(a => a.id === id);
        if (index !== -1) {
            const old = absences[index];
            const targetUser = db.getUsers().find(u => u.id === old.userId) || currentUser;
            const wasApproved = old.status === 'Genehmigt';

            // Reset status to Beantragt if modified by employee (unless it is a sick note or admin edit)
            const newStatus = (type === 'Krankheit') ? 'Genehmigt' : (currentUser.role === 'admin' ? old.status : 'Beantragt');

            absences[index] = {
                ...old,
                type,
                startDate,
                endDate,
                daysCount,
                status: newStatus
            };

            const formatOldS = new Date(old.startDate).toLocaleDateString('de-DE');
            const formatOldE = new Date(old.endDate).toLocaleDateString('de-DE');
            const formatNewS = new Date(startDate).toLocaleDateString('de-DE');
            const formatNewE = new Date(endDate).toLocaleDateString('de-DE');

            logActivity(
                currentUser.id,
                currentUser.name,
                type,
                'Geändert',
                \`Abwesenheit (\${type}) für \${targetUser.name} angepasst: \${formatOldS}-\${formatOldE} ➔ \${formatNewS}-\${formatNewE} (\${daysCount} Tage)\`
            );

            showToast(wasApproved && newStatus === 'Beantragt' ? 'Urlaubsantrag angepasst & erneut zur Genehmigung eingereicht' : 'Abwesenheit aktualisiert', 'success');
        }
    } else {
        const newAbsence = {
            id: 'a-' + Date.now(),
            userId: currentUser.id,
            type,
            startDate,
            endDate,
            daysCount,
            status: type === 'Krankheit' ? 'Genehmigt' : 'Beantragt'
        };

        absences.push(newAbsence);

        const formatS = new Date(startDate).toLocaleDateString('de-DE');
        const formatE = new Date(endDate).toLocaleDateString('de-DE');

        logActivity(
            currentUser.id,
            currentUser.name,
            type,
            'Erstellt',
            \`\${type}-Antrag/Eintrag von \${formatS} bis \${formatE} (\${daysCount} Tage) eingereicht\`
        );

        showToast(type === 'Urlaub' ? 'Urlaubsantrag eingereicht' : 'Krankmeldung erfasst', 'success');
    }

    db.saveAbsences(absences);
    closeModal('modal-absence');

    if (currentUser.role === 'admin') {
        loadAdminDashboard();
    } else {
        loadEmployeeDashboard();
    }
};

window.deleteAbsence = function(id) {
    let absences = db.getAbsences();
    const entry = absences.find(a => a.id === id);

    if (entry) {
        const formatS = new Date(entry.startDate).toLocaleDateString('de-DE');
        const formatE = new Date(entry.endDate).toLocaleDateString('de-DE');
        logActivity(
            currentUser.id,
            currentUser.name,
            entry.type,
            'Gelöscht',
            \`\${entry.type}-Antrag (\${formatS} bis \${formatE}, \${entry.daysCount} Tage) storniert/gelöscht\`
        );
    }

    absences = absences.filter(a => a.id !== id);
    db.saveAbsences(absences);
    showToast('Abwesenheit storniert', 'info');

    if (currentUser.role === 'admin') {
        loadAdminDashboard();
    } else {
        loadEmployeeDashboard();
    }
};

window.approveAbsence = function(id) {
    let absences = db.getAbsences();
    const index = absences.findIndex(a => a.id === id);
    if (index !== -1) {
        absences[index].status = 'Genehmigt';
        const a = absences[index];
        const targetUser = db.getUsers().find(u => u.id === a.userId) || { name: 'Mitarbeiter' };

        logActivity(
            currentUser.id,
            currentUser.name,
            a.type,
            'Genehmigt',
            \`Urlaubsantrag von \${targetUser.name} (\${a.startDate} bis \${a.endDate}, \${a.daysCount} Tage) genehmigt\`
        );

        db.saveAbsences(absences);
        showToast('Urlaubsantrag genehmigt', 'success');
        loadAdminDashboard();
    }
};

window.rejectAbsence = function(id) {
    let absences = db.getAbsences();
    const index = absences.findIndex(a => a.id === id);
    if (index !== -1) {
        absences[index].status = 'Abgelehnt';
        const a = absences[index];
        const targetUser = db.getUsers().find(u => u.id === a.userId) || { name: 'Mitarbeiter' };

        logActivity(
            currentUser.id,
            currentUser.name,
            a.type,
            'Abgelehnt',
            \`Urlaubsantrag von \${targetUser.name} (\${a.startDate} bis \${a.endDate}) abgelehnt\`
        );

        db.saveAbsences(absences);
        showToast('Urlaubsantrag abgelehnt', 'info');
        loadAdminDashboard();
    }
};

window.deleteAdminAbsence = function(id) {
    let absences = db.getAbsences();
    const entry = absences.find(a => a.id === id);

    if (entry) {
        const targetUser = db.getUsers().find(u => u.id === entry.userId) || { name: 'Mitarbeiter' };
        logActivity(
            currentUser.id,
            currentUser.name,
            entry.type,
            'Gelöscht',
            \`\${entry.type}-Eintrag von \${targetUser.name} (\${entry.startDate} bis \${entry.endDate}) gelöscht\`
        );
    }

    absences = absences.filter(a => a.id !== id);
    db.saveAbsences(absences);
    showToast('Eintrag gelöscht', 'info');
    loadAdminDashboard();
};

window.openUserModal = function() {
    document.getElementById('form-user').reset();
    document.getElementById('user-edit-id').value = '';
    document.getElementById('modal-user-title').textContent = 'Neuen Mitarbeiter anlegen';
    document.getElementById('modal-user').classList.remove('hidden');
};

window.editUser = function(id) {
    const users = db.getUsers();
    const user = users.find(u => u.id === id);
    if (!user) return;

    document.getElementById('user-edit-id').value = user.id;
    document.getElementById('user-name').value = user.name;
    document.getElementById('user-username').value = user.username;
    document.getElementById('user-password').value = user.password;
    document.getElementById('user-role').value = user.role;
    document.getElementById('user-hourly-rate').value = user.hourlyRate || 20.00;
    document.getElementById('user-vacation-days').value = user.vacationQuota || 30;

    document.getElementById('modal-user-title').textContent = 'Mitarbeiter bearbeiten';
    document.getElementById('modal-user').classList.remove('hidden');
};

window.deleteUser = function(id) {
    if (!currentUser || currentUser.role !== 'admin') {
        showToast('Nur Administratoren dürfen Mitarbeiter löschen.', 'error');
        return;
    }

    const users = db.getUsers();
    const user = users.find(u => u.id === id);

    if (!user) {
        showToast('Mitarbeiter nicht gefunden.', 'error');
        return;
    }

    // Der aktuell eingeloggte Administrator darf nicht versehentlich gelöscht werden.
    if (user.id === currentUser.id) {
        showToast('Der aktuell angemeldete Administrator kann nicht gelöscht werden.', 'error');
        return;
    }

    const confirmed = confirm(
        \`Mitarbeiter wirklich löschen?\\n\\n\${user.name} (@\${user.username})\\n\\n\` +
        \`Dabei werden auch die zugehörigen Arbeitszeiten und Abwesenheiten gelöscht. \` +
        \`Dieser Vorgang kann nicht rückgängig gemacht werden.\`
    );

    if (!confirmed) return;

    const remainingUsers = users.filter(u => u.id !== id);

    // Zugehörige Daten ebenfalls entfernen, damit keine verwaisten Datensätze bleiben.
    const remainingHours = db.getHours().filter(h => h.userId !== id);
    const remainingAbsences = db.getAbsences().filter(a => a.userId !== id);

    db.saveUsers(remainingUsers);
    db.saveHours(remainingHours);
    db.saveAbsences(remainingAbsences);

    // Löschung im Änderungsprotokoll dokumentieren.
    logActivity(
        currentUser.id,
        currentUser.name,
        'Benutzer',
        'Gelöscht',
        \`Mitarbeiter \${user.name} (@\${user.username}) wurde aus dem System gelöscht. Zugehörige Arbeitszeiten und Abwesenheiten wurden ebenfalls entfernt.\`
    );

    showToast(\`Mitarbeiter \${user.name} wurde gelöscht.\`, 'success');
    loadAdminDashboard();
};

window.handleSaveUser = function(e) {
    e.preventDefault();
    const id = document.getElementById('user-edit-id').value;
    const name = document.getElementById('user-name').value.trim();
    const username = document.getElementById('user-username').value.trim();
    const password = document.getElementById('user-password').value.trim();
    const role = document.getElementById('user-role').value;
    const hourlyRate = parseFloat(document.getElementById('user-hourly-rate').value) || 20.00;
    const vacationQuota = parseInt(document.getElementById('user-vacation-days').value) || 30;

    let users = db.getUsers();

    if (id) {
        const index = users.findIndex(u => u.id === id);
        if (index !== -1) {
            users[index] = { ...users[index], name, username, password, role, hourlyRate, vacationQuota };

            logActivity(
                currentUser.id,
                currentUser.name,
                'Benutzer',
                'Geändert',
                \`Mitarbeiterdaten von \${name} (@\${username}) aktualisiert\`
            );

            showToast('Mitarbeiterdaten aktualisiert', 'success');
        }
    } else {
        if (users.some(u => u.username.toLowerCase() === username.toLowerCase())) {
            showToast('Benutzername bereits vergeben!', 'error');
            return;
        }
        const newUser = { id: 'u-' + Date.now(), name, username, password, role, hourlyRate, vacationQuota };
        users.push(newUser);

        logActivity(
            currentUser.id,
            currentUser.name,
            'Benutzer',
            'Erstellt',
            \`Neuer Mitarbeiter \${name} (@\${username}) angelegt\`
        );

        showToast('Neuer Mitarbeiter erfolgreich angelegt', 'success');
    }

    db.saveUsers(users);
    closeModal('modal-user');
    loadAdminDashboard();
};

window.showAuditLog = function(id) {
    if (currentUser.role !== 'admin') return;

    const hours = db.getHours();
    const entry = hours.find(h => h.id === id);
    if (!entry || !entry.editHistory || entry.editHistory.length === 0) {
        showToast('Keine historischen Änderungen für diesen Eintrag protokolliert', 'info');
        return;
    }

    const container = document.getElementById('audit-log-content');
    container.innerHTML = entry.editHistory.map((hist) => {
        const dateStr = new Date(hist.modifiedAt).toLocaleString('de-DE');
        const diffHours = hist.newNetHours - hist.oldNetHours;
        const diffStr = diffHours > 0 ? \`+\${diffHours.toFixed(2)} h\` : \`\${diffHours.toFixed(2)} h\`;
        const diffColor = diffHours > 0 ? 'text-emerald-600' : diffHours < 0 ? 'text-rose-600' : 'text-slate-500';

        return \`
            <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 text-xs space-y-2">
                <div class="flex justify-between items-center text-slate-500 font-medium">
                    <span><i class="fa-solid fa-user-pen mr-1"></i>Geändert von: <strong class="text-slate-800">\${hist.modifiedBy}</strong></span>
                    <span>\${dateStr}</span>
                </div>
                <div class="grid grid-cols-2 gap-2 pt-1">
                    <div class="bg-rose-50 border border-rose-200 p-2.5 rounded-lg text-rose-900">
                        <div class="font-bold uppercase text-[10px] text-rose-600 mb-1">Vorher</div>
                        <div>Datum: \${hist.oldDate}</div>
                        <div>Zeit: \${hist.oldStart} - \${hist.oldEnd} Uhr</div>
                        <div class="font-semibold mt-1">Dauer: \${hist.oldNetHours.toFixed(2)} h</div>
                    </div>
                    <div class="bg-emerald-50 border border-emerald-200 p-2.5 rounded-lg text-emerald-900">
                        <div class="font-bold uppercase text-[10px] text-emerald-600 mb-1">Nachher</div>
                        <div>Datum: \${hist.newDate}</div>
                        <div>Zeit: \${hist.newStart} - \${hist.newEnd} Uhr</div>
                        <div class="font-semibold mt-1">Dauer: \${hist.newNetHours.toFixed(2)} h</div>
                    </div>
                </div>
                <div class="text-right pt-1 font-semibold \${diffColor}">Differenz: \${diffStr}</div>
            </div>
        \`;
    }).join('');

    document.getElementById('modal-audit-log').classList.remove('hidden');
};

window.closeModal = function(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.add('hidden');
};

window.exportCSV = function() {
    const hours = db.getHours();
    const users = db.getUsers();

    if (hours.length === 0) {
        showToast('Keine Daten zum Exportieren vorhanden', 'error');
        return;
    }

    let csvContent = "data:text/csv;charset=utf-8,Mitarbeiter;Benutzername;Datum;Start;Ende;Stunden;Stundenlohn EUR;Verdienst EUR\\n";

    hours.forEach(h => {
        const u = users.find(usr => usr.id === h.userId) || { name: 'Unbekannt', username: '-', hourlyRate: 0 };
        const netHours = calculateNetHours(h.start, h.end);
        const earnings = netHours * (parseFloat(u.hourlyRate) || 0);

        csvContent += \`"\${u.name}";"\${u.username}";"\${h.date}";"\${h.start}";"\${h.end}";"\${netHours.toFixed(2)}";"\${(parseFloat(u.hourlyRate) || 0).toFixed(2)}";"\${earnings.toFixed(2)}"\\n\`;
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", \`Zeiterfassung_Export_\${new Date().toISOString().split('T')[0]}.csv\`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    showToast('CSV-Export wurde heruntergeladen', 'success');
};

// Application Startup
window.addEventListener('load', () => {
    initDatabase();
    currentUser = db.getCurrentUser();
    if (currentUser) {
        startSession();
    }
});
</script>
</body>
</html>`;

function TimeMaster() {
  return (
    <iframe
      title="TimeMaster Pro"
      srcDoc={TIME_MASTER_HTML}
      style={{
        display: "block",
        width: "100%",
        height: "100vh",
        border: "none",
      }}
    />
  );
}

export default TimeMaster;
